function popErrMsg(hthis,status,statusText) {
  let arr = ['后台API错误，请联系系统管理员.']
  let msg = '错误码：' + status + '. 错误信息：' +  statusText + '.'
  arr.push(msg)
  msg = arr.join('<br/>')

  hthis.$alert(msg, '错误信息', {
    confirmButtonText: '确定',
    dangerouslyUseHTMLString: true,
    type: 'warning'
  })
  
}
export {
  popErrMsg,
};


// WEBPACK FOOTER //
// ./src/js/hgisUtil.js